export default "__VITE_ASSET__BaEUf0J8__"